import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import HLabel from "@cloudpivot/form/src/common/components/label.vue";
let SheetStatistic = class SheetStatistic extends Vue {
    render(h) {
        return h('h-label', { props: { control: this.control
            }, style: { "justifyContent": "center" } });
    }
};
tslib_1.__decorate([
    Prop()
], SheetStatistic.prototype, "control", void 0);
SheetStatistic = tslib_1.__decorate([
    Component({
        name: 'SheetStatistic',
        components: {
            HLabel: HLabel
        }
    })
], SheetStatistic);
export default SheetStatistic;
